// extracted by mini-css-extract-plugin
export default {"layout":"Modal_layout__eAlE1","box":"Modal_box__3CnXA","closeButton":"Modal_closeButton__3V9B-","title":"Modal_title__KuCmT"};